// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-colorful{width:100% !important;height:100% !important;gap:5% !important;margin-top:2.5% !important;margin-bottom:2.5% !important}.react-colorful__saturation{border-radius:6px !important}.react-colorful__hue{border-radius:6px !important;max-height:10px !important}.react-colorful__pointer{width:15px !important;height:15px !important}", ""]);
// Exports
module.exports = exports;
